export const en = {
  campaigns: {
    dailyLabel: '└─Daily',
    reportTexts: {
      createReportError: 'Report creation error '
    }
  },
  scenarios: {
    konstruktor: {
      canvas: {
        add: {
          sendSMS: 'send SMS',
          sendHttpRequest: 'send Http Request'
        },
        answer: {
          initAudio: {
            toPutUrl: 'Enter url',
            putUrl: 'Enter url',
            toAddUrl: 'Add url',
            toRemoveUrl: 'RemoveUrl',

            toUploadFromFile: 'Upload from file',
            toRemoveAll: 'Remove all',

            toAddParameter: 'Add Parameter',
            putParameterName: 'Enter Parameter',
            addParameter: 'Add Parameter',
            toRemoveParameter: 'Remove Parameter',

            Your_browser_does_not_support_html5_audio_Try_chrome: 'Your browser does not support html5 audio Try chrome'
          }
        }
      }
    }
  },
  callTasks: {
    states: {
      telephony_error_suspend: 'telephony error suspend'
    }
  },
  common: {
    timeInterval:{
      from: 'since',
      to: 'to'
    },
    actions: {
      reCreate: 'Recreate'
    }
  },
  testCall: {
    toPhoneNote: 'to call a phone, there must be a campaign with settings for outgoing calls',
    inBrowserNote: 'to call in the browser you must enable the microphone and reload the page'
  }
}



// WEBPACK FOOTER //
// ./client/translations/en.js